import Vue from 'vue'
import './plugins/fontawesome'
import 'remixicon/fonts/remixicon.css'
import App from './App'
import router from './router'
import { store } from './store.js'
const fb = require('./firebaseConfig.js')

import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import './assets/scss/app.scss'

import VeeValidate from 'vee-validate'
import VueScrollTo from 'vue-scrollto'
import SocialSharing from 'vue-social-sharing'
import vueFilterPrettyBytes from 'vue-filter-pretty-bytes'
import VueCurrencyInput from 'vue-currency-input'
import i18n from './i18n'

Vue.use(Buefy)

Vue.use(VeeValidate, {
  events: ''
})
Vue.use(VueScrollTo)
Vue.use(SocialSharing)
Vue.use(vueFilterPrettyBytes)
Vue.use(VueCurrencyInput)

Vue.config.productionTip = false

// handle page reloads
let app
fb.auth.onAuthStateChanged(user => {
  if (!app) {
    app = new Vue({
      el: '#app',
      router,
      store,
      i18n,
      render: h => h(App)
    })
  }
})

